<template>
  <v-simple-table dense class="select_tarrif">
    <template v-slot:default>
      <thead>
        <tr>
          <td></td>
          <td class="text-center" v-for="tariff in tariffs" :key="tariff.id">
            {{ tariff.title }}
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Расчеты по коммерции:</td>
          <td class="text-center" v-for="tariff in tariffs" :key="tariff.id">
            {{ tariff.comercial_calc }}
          </td>
        </tr>
        <tr>
          <td>Дополнительные фильтры по ситуации:</td>
          <td class="text-center" v-for="tariff in tariffs" :key="tariff.id">
            {{ tariff.dop_situation_filter }}
          </td>
        </tr>
        <tr>
          <td>Дополнительные фильтры по заказчикам:</td>
          <td class="text-center" v-for="tariff in tariffs" :key="tariff.id">
            {{ tariff.dop_customer_filter }}
          </td>
        </tr>
        <tr>
          <td>Фильтры в результатах расчета:</td>
          <td class="text-center" v-for="tariff in tariffs" :key="tariff.id">
            {{ tariff.calc_filter }}
          </td>
        </tr>
        <tr>
          <td>Количество расчетов в пакете:</td>
          <td class="text-center" v-for="tariff in tariffs" :key="tariff.id">
            {{
              tariff.count_request > 0
                ? `${tariff.count_request}`
                : "Не ограничено"
            }}
          </td>
        </tr>
        <tr>
          <td>Срок действия пакета:</td>
          <td class="text-center" v-for="tariff in tariffs" :key="tariff.id">
            {{
              tariff.valid_period > 0
                ? `${tariff.valid_period} дней`
                : "Не ограничено"
            }}
          </td>
        </tr>
        <tr>
          <td>История расчетов:</td>
          <td class="text-center" v-for="tariff in tariffs" :key="tariff.id">
            {{ getBooleanToPlus(tariff.history_request) }}
          </td>
        </tr>
        <tr>
          <td>
            Добавление новых пользователей <br />
            (только для ЮЛ и ИП):
          </td>
          <td class="text-center" v-for="tariff in tariffs" :key="tariff.id">
            {{ getBooleanToPlus(tariff.add_users) }}
          </td>
        </tr>
        <tr>
          <td>Скачивание расчета:</td>
          <td class="text-center" v-for="tariff in tariffs" :key="tariff.id">
            {{ getBooleanToPlus(tariff.download_report) }}
          </td>
        </tr>
        <tr>
          <td>Время ответа техподдержки (не более, рабочее время):</td>
          <td class="text-center" v-for="tariff in tariffs" :key="tariff.id">
            {{
              tariff.time_support === 0
                ? `Не осуществляется`
                : `${tariff.time_support}`
            }}
          </td>
        </tr>
        <tr>
          <td>Персональный менеджер:</td>
          <td class="text-center" v-for="tariff in tariffs" :key="tariff.id">
            {{ getBooleanToPlus(tariff.personal_manager) }}
          </td>
        </tr>
        <!-- <tr>
          <td>Приоритетный учет пожеланий к доработке сервиса:</td>
          <td class="text-center" v-for="tariff in tariffs" :key="tariff.id">
            {{ getBooleanToPlus(tariff.add_improvement) }}
          </td>
        </tr> -->
        <tr>
          <td>API для размещения на своём ресурсе:</td>
          <td class="text-center" v-for="tariff in tariffs" :key="tariff.id">
            {{ getBooleanToPlus(tariff.api) }}
          </td>
        </tr>
        <tr>
          <td>Оплата:</td>
          <td class="text-center" v-for="tariff in tariffs" :key="tariff.id">
            {{ Array.from(tariff.payment_type).join(", ") }}
          </td>
        </tr>
        <tr>
          <td>Стоимость:</td>
          <td class="text-center" v-for="tariff in tariffs" :key="tariff.id">
            {{
              `${tariff.price} руб. \n (${
                tariff.price / tariff.count_request
              } руб./расчет)`
            }}
          </td>
        </tr>
        <tr style="background: transparent">
          <td></td>
          <td class="text-center" v-for="tariff in tariffs" :key="tariff.id">
            <v-btn
              outlined
              rounded
              class="accent"
              text
              @click="selectTarrif(tariff)"
              style="margin: 10px; color: white"
            >
              Выбрать
            </v-btn>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
  <!-- <div class="select_tarrif">
    <v-list-item-content >
      <div class="mb-4">Количество расчетов:</div>
      <div class="mb-4">История расчетов:</div>
      <div class="mb-4">Добавление пользователей (ЮЛ и ИП):</div>
      <div class="mb-4">Скачивание расчета:</div>
      <div class="mb-4">
        Уведомления пользователей о победах своих клиентов (44-ФЗ, 615-ПП):
      </div>
      <div class="mb-4">
        Время ответа техподдержки (не более, рабочее время):
      </div>
      <div class="mb-4">Персональный менеджер:</div>
      <div class="mb-4">Приоритетный учет пожеланий к доработке сервиса:</div>
      <div class="mb-4">Доступ к закрытому агентскому чату в Телеграмм:</div>
      <div class="mb-4">Оплата:</div>
      <div class="mb-4">Стоимость:</div>
    </v-list-item-content>
    <Tariff
      @select="selectTarrif($event)"
      :item="tariff"
      class='text-center' v-for="tariff in tariffs"
      :key="tariff.id"
      :active="select && select.id === tariff.id"
    />
  </div> -->
</template>
<script>
// import Tariff from "./Tariff";
export default {
  name: "select_tarrif",
  components: {
    // Tariff,
  },
  data: () => ({}),
  methods: {
    getBooleanToPlus(data) {
      return data == 1 ? "+" : "-";
    },
    getTarrifLine() {
      this.$store.dispatch("GET_PAYMENTS_TARIFFS");
    },
    selectTarrif(item) {
      this.select = item;
      const type =
        item && item.payment_type[0] == "на расчетный счет" ? "bank" : "card";
      this.$store.commit("setSelectedPaymentType", type);
      this.$emit("tariffSelect", item);
    },
  },
  computed: {
    tariffs() {
      return this.$store.getters.tariffs;
    },
    select: {
      get() {
        return this.$store.getters.selectedTariff;
      },
      set(val) {
        this.$store.commit("setselectedTariff", val);
      },
    },
  },
  created() {
    this.getTarrifLine();
  },
};
</script>
<style lang="sass" scoped></style>
